import * as React from "react"
import { cn } from "@/shared/utils/utils"
import { IronviewLogo } from "@/shared/components/IronviewLogo"

interface LogoLoadingProps extends React.HTMLAttributes<HTMLDivElement> {
	message?: string | null | undefined
	fullScreen?: boolean
	size?: "sm" | "md" | "lg" | "xl"
	variant?: "fade" | "pulse" | "breathing"
}

const LogoLoading = React.forwardRef<HTMLDivElement, LogoLoadingProps>(
	(
		{
			className,
			size = "md",
			variant = "breathing",
			fullScreen = false,
			message = null,
			...props
		},
		ref
	) => {
		const sizeClasses = {
			sm: "w-24 h-auto", // ~100px
			md: "w-48 h-auto", // ~200px
			lg: "w-64 h-auto", // ~256px
			xl: "w-96 h-auto", // ~384px
		}

		const containerClasses = cn(
			"flex flex-col items-center justify-center gap-4",
			fullScreen && "fixed inset-0 bg-background/95 backdrop-blur-sm z-50 slate-glow",
			className
		)

		// Animation variants
		const animationClasses = {
			fade: "animate-fade-in-out",
			pulse: "animate-pulse-smooth",
			breathing: "animate-breathing",
		}

		return (
			<div ref={ref} className={containerClasses} {...props}>
				<div className="relative">
					<IronviewLogo
						alt="Ironview 360 Loading"
						className={cn(
							sizeClasses[size],
							animationClasses[variant],
							"select-none"
						)}
						draggable={false}
					/>
				</div>
				{message && (
					<p className="text-muted-foreground text-sm animate-fade-in-delayed">
						{message}
					</p>
				)}
			</div>
		)
	}
)

LogoLoading.displayName = "LogoLoading"

export { LogoLoading }
